
import MainLayout from "@/components/layout/MainLayout";
import { AIWorkflowController } from "@/components/ai/AIWorkflowController";

const AIWorkflows = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">AI Workflows</h1>
          <p className="text-muted-foreground">
            Configure, execute, and review your automated data pipeline.
          </p>
        </div>
        <AIWorkflowController />
      </div>
    </MainLayout>
  );
};

export default AIWorkflows;
